import { connect } from 'react-redux'
import BackLink from './back-link'
import { withRouter } from 'react-router-dom'
import { getAssessmentFile } from '../../../../../stores/assessment-file/assessment-file.selectors'
import { getWorksAssessmentFileTitle } from '../../../../../stores/works/works.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { match, history, me }) => {
  const assessmentFile = getAssessmentFile(state)
  const title =
    (assessmentFile && assessmentFile.title) ||
    getWorksAssessmentFileTitle(state)
  const canManageAFs =
    me &&
    me.account &&
    me.account.policy &&
    me.account.policy.can_manage_assessment_files
  return {
    url: match.params.workId
      ? `/assessment-files/${match.params.assessmentFileId}`
      : `${canManageAFs ? '/my-files' : '/'}`,
    link: match.params.workId ? `Back to ${title}` : `Back to Moderation`
  }
}

export default withRouter(withMe(connect(mapStateToProps, null)(BackLink)))
